import { UpdateFirebaseUserIdState } from './updateFirebaseUserId.types'

const initialState: UpdateFirebaseUserIdState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
